<ion-header>
  <ion-toolbar>
    <ion-title>{{'Officials' | translate}}</ion-title>

    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-searchbar placeholder="{{'Search' | translate}}" (ionInput)="onSearchChange($event)" [debounce]="250"></ion-searchbar>

  <ion-toolbar [hidden]="!isEdit || !filteredOfficials()?.length">
    <ion-item>
      <ion-select label="{{'Actions' | translate}}" #settingsOptions value="AVAILABILITY" interface="popover">
        <ion-select-option value="AVAILABILITY">{{'Availability' | translate}}</ion-select-option>
        <ion-select-option value="VENUE">{{'Venue' | translate}}</ion-select-option>
        <ion-select-option value="REMOVE">{{'Remove' | translate}}</ion-select-option>
      </ion-select>
    </ion-item>
  </ion-toolbar>

  @defer (when loaded()) {
    @if (_tournamentId && tournament$ | async; as tournament) {

      <ion-accordion-group #accordionGroup class="content-width">
        <ion-accordion value="colors">
    
          <ion-item slot="header">
            <ion-label>{{'Filters' | translate}}</ion-label>
            <ion-icon slot="start" name="filter"></ion-icon>
          </ion-item>
    
          <ion-list slot="content">
            <ion-item>
              <ion-select label="{{'Availability' | translate}}" labelPlacement="stacked" [(ngModel)]="available" interface="popover">
                <ion-select-option value="ALL">{{'Show all' | translate}}</ion-select-option>
                <ion-select-option value="AVAILABLE">{{'Available' | translate}}</ion-select-option>
                <ion-select-option value="NOT_AVAILABLE">{{'Not available' | translate}}</ion-select-option>
              </ion-select>
            </ion-item>
    
            <ion-item>
              <ion-select label="{{'Venue' | translate}}" labelPlacement="stacked" [value]="selectedVenue" (ionChange)="setVenue($event)" interface="popover" placeholder="{{'Select venue' | translate}}">
                <ion-select-option [value]="'ALL'">{{'All' | translate}}</ion-select-option>
                @for (venue of tournament.venues; track $index) {
                  <ion-select-option [value]="venue._id">{{ venue.venueAbbreviation }}</ion-select-option>
                }
              </ion-select>
            </ion-item>
          </ion-list>
    
        </ion-accordion>
      </ion-accordion-group>

      @if (filteredOfficials().length) {
        <ion-list>
          @for (official of filteredOfficials(); let i = $index; track i;) {
            @if (applyFilter(official)) {
              @if (isEdit) {
                <ion-item>
                    @if (settingsOptions?.value === 'AVAILABILITY') {
                      <ion-toggle [checked]="official.isAvailable" justify="space-between" (ionChange)="setAvailability($event, i)">
                        <div>
                          <ng-container *ngTemplateOutlet="officialInfo; context: { $implicit: official }"></ng-container>
                        </div>
                      </ion-toggle>
                    } @else if (settingsOptions?.value === 'VENUE') {
                      <ion-select [value]="official.venue?._id" interface="popover" placeholder="Select venue" (ionChange)="updateVenue($event, official._id)">
                        <div slot="label">
                          <ng-container *ngTemplateOutlet="officialInfo; context: { $implicit: official }"></ng-container>
                        </div>
                        <ion-select-option [value]="null">{{'None' | translate}}</ion-select-option>
                        @for (venue of tournament.venues; track $index) {
                          <ion-select-option [value]="venue._id">{{ venue.venueAbbreviation }}</ion-select-option>
                        }
                      </ion-select>
                    } @else if (settingsOptions?.value === 'REMOVE') {
                      <ion-label>
                        <ng-container *ngTemplateOutlet="officialInfo; context: { $implicit: official }"></ng-container>
                      </ion-label>
                      <ion-button slot="end" color="danger" (click)="removeOfficial(official.user._id, i)">
                        {{'Remove' | translate}}
                      </ion-button>
                    }
                </ion-item>
              } @else {
                <ion-item button (click)="selectOfficial(official)">
                  <ion-label>
                    <ng-container *ngTemplateOutlet="officialInfo; context: { $implicit: official }"></ng-container>
                  </ion-label>
                </ion-item>
              }
            }
          }
        </ion-list>
      } @else {
          <app-empty-page text="You don't have any officials. Add official or adjust filters." iconName="people"></app-empty-page>
      }
    }
  } @loading (minimum 0.6s) {
    <ion-loading isOpen="true" name="crescent"></ion-loading>
  }

  @if (isEdit) {
    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
      <ion-fab-button (click)="chooseAddOfficialMethod()">
          <ion-icon name="add"></ion-icon>
      </ion-fab-button>
    </ion-fab>
  }
</ion-content>

<ng-template #officialInfo let-official>
  {{ official.user.first_name }} {{ official.user.last_name }} ({{ official.matchUpAssignments?.length }})
  <ion-text color="gray">
    <p style="font-size: 13px;" class="ion-no-margin">Last match: {{ getStartDate(official) }}{{ getEndDate(official) }} {{getCourtName(official)}}</p>
  </ion-text>
</ng-template>
